import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.34997 38.5119C4.34997 38.5119 4.34001 27.9519 8.89001 17.7919C12.64 9.4219 12.08 1.94189 12.08 1.94189C12.08 1.94189 5.86001 4.8219 3.39001 11.8719C1.21001 18.0519 0.769973 26.8419 4.34997 38.5119Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M53.13 38.5119C53.13 38.5119 53.14 27.9519 48.59 17.7919C44.84 9.4219 45.4 1.94189 45.4 1.94189C45.4 1.94189 51.62 4.8219 54.09 11.8719C56.26 18.0519 56.71 26.8419 53.13 38.5119Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
